import './route-stations.css';
export const RouteStations = {
        props: {
                is_active: {
                        type: Boolean,
                        required: true,
                },
                trip_id: {
                        type: Boolean,
                        required: true,
                },
                departure_id: {
                        type: Boolean,
                        required: true,
                },
                destination_id: {
                        type: Boolean,
                        required: true,
                },
        },
        created() {
        },
        data(): object {
            return {
                    month: [
                        'января',
                        'февраля',
                        'марта',
                        'апреля',
                        'мая',
                        'июня',
                        'июля',
                        'августа',
                        'сентября',
                        'октября',
                        'ноября',
                        'декабря',
                    ],
                    segment: {},
            }
        },
        computed: {},
        watch: {
                is_active(isActive) {
                        if (
                            isActive === true &&
                            typeof this.segment.Route === 'undefined'
                        ) {
                                this.getSegments(
                                    this.trip_id,
                                    this.departure_id,
                                    this.destination_id
                                );
                        }
                },
        },
        methods: {
                convertTime2Minutes(time)
                {

                        let res_date = time.substring(11, 19).split(':');
                        return res_date[0] + ':' + res_date[1];
                },
                convertTime2Date(time) {
                        let res_date = new Date(time);

                        return res_date.getDate() + ' ' + this.month[res_date.getMonth()];
                },
                loading_on()
                {

                        this.$Bitrix.eventEmitter.emit('akatan:search_routes:loading_on', {});
                },

                loading_off()
                {
                        this.$Bitrix.eventEmitter.emit('akatan:search_routes:loading_off', {});
                },
                async getSegments(trip_id, departure_id, destination_id)
                {
                        await this.loading_on();
                        const params = {
                                status: 'get_segments',
                                ajax: 'yes',
                                route: {
                                        trip_id,
                                        departure_id,
                                        destination_id,
                                },
                        };
                        const  jsonData = JSON.stringify(params);
                        try {
                                const response = await fetch(
                                    '/local/js/akatan/search_routes/ajax.php',
                                    {
                                            method: 'POST',
                                            headers: new Headers({
                                                    "Content-Type": "application/json",
                                            }),
                                            body: jsonData,
                                    }
                                );
                                const res_segments = await response.json();
                                if (res_segments.state === 'success') {
                                        this.segment = res_segments.suggestions.segments;
                                }
                                if (res_segments.state === 'error') {
                                        this.handlerErrors(res_segments.suggestions);
                                }
                        } catch (error) {
                                console.error(error)
                        } finally {
                                this.loading_off()
                        }
                },
        },
        template: `<div className="routs-table__route-stations route-stations" v-if="is_active === true">
                <div
                    className="route-stations__points"
                    v-if="typeof segment.Route !== 'undefined'"
                >
                    <div className="route-point" v-for="(route, route_index) in segment.Route" :key="route_index">
                        <div className="route-point__date" >
                            <div className="route-point__time">{{convertTime2Minutes(route.ArrivalTime)}}</div>
                            <div className="route-point__number" v-if="route_index === 0 && typeof segment.DepartureTime !== 'undefined'">{{convertTime2Date(segment.DepartureTime)}}</div>
                            <div className="route-point__number" v-if="route_index === (segment.Route.length - 1) && typeof segment.ArrivalTime !== 'undefined'">{{convertTime2Date(segment.ArrivalTime)}}</div>
                        </div>
                        <div className="route-point__info">
                            <div className="route-point__location">{{route.BusStop.Name}}</div>
                            <div className="route-point__address">{{route.BusStop.Address}}</div>
                        </div>
                    </div>
                </div>
            </div>`
}